import { Box, Typography, useTheme } from "@mui/material";

import { useFormik } from "formik";
import { addCommas } from "@persian-tools/persian-tools";
import ModalLayout from "../../../../../../components/ModalLayout";
import InfoFillCircle from "../../../../../../../media/images/icons/infofill-circle";
import Boxoutline from "../../../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../../../media/images/icons/location-fill";
import CustomButton from "../../../../../../components/CustomButton";
import CloseCircleSVG from "../../../../../../../media/images/icons/close-icon";
import {
  convertToJalali,
  convertToPersianDate,
} from "../../../../../../../utils/functions";
import CheckCircle from "../../../../../../../media/images/icons/check-circle";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarChildren,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../../redux/features/snackbarSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../hooks/useRedux";
import {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../../redux/features/dialogSlice";
import { useNavigate } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../../media/images/icons/arrow-left";
import { blueGrey } from "@mui/material/colors";

interface Props {
  open: boolean;
  handleClose: () => void;
  companyName: string;
  description: string;
  ladingLocationInfoAddress: string;
  packageTypeName: string;
  orderDateEn: string;
  orderId: string;
  weight: number;
  remainder: number;
  id: string;
  goodsName: string;
  destination: string;
  fare: number;
  ladingDate: string;
  onUnauthorized?: () => void;
}
export default function GetCargoModal(props: Props) {
  const theme = useTheme();

  const navigate = useNavigate();

  const {
    handleClose,
    open,
    goodsName,
    destination,
    fare,
    description,
    ladingLocationInfoAddress,
    ladingDate,
    orderId,
    onUnauthorized,
  } = props;

  const dispatch = useAppDispatch();
  const { salonInfo } = useAppSelector(
    (state) => state.user.driverNobatQueueInfo
  );

  const formik = useFormik({
    initialValues: {
      orderId: "",
    },
    onSubmit: () => {
      postGetLoad({
        orderId,
      });
      // .catch((e) => {
      //   dispatch(setOpenSnackbar(true));
      //   dispatch(setSnackbarErrorStatus(e.response.data.errorCode));
      //   dispatch(setSnackbarDescription(e.response.data.error));
      //   if (!salonInfo)
      //     dispatch(
      //       setSnackbarChildren(
      //         <CustomButton
      //           flex={1}
      //           // loading={true}
      //           flexDirection="row-reverse"
      //           justifyContent="center"
      //           onClick={() => {
      //             navigate("../check-in");
      //             dispatch(setOpenSnackbar(false));
      //           }}
      //           title="اعلام حضور"
      //           bgColor="primary.main"
      //           textColor="#fff"
      //           fWeight="700"
      //           px="10px"
      //           py="12px"
      //           mt="12px"
      //           borderRadius="10px"
      //           icon1={<ArrowLeftSVG size={26} color={"#fff"} />}
      //         />
      //       )
      //     );
      // });
    },
  });

  const { trigger: postGetLoad } = useSWRMutation(
    [`/Nobat/NobatAddOrder_ByDriver`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        handleClose();

        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("دریافت بار"));
        dispatch(setDialogDescription("بار مورد نظر دریافت شد!"));

        setTimeout(() => {
          dispatch(setOpenDialog(false));
        }, 4000);
      },
      onError: (e: { response?: { status?: number } }) => {
        const status = e?.response?.status;
        if ((status === 401 || status === 403) && onUnauthorized) {
          localStorage.removeItem("access_token");
          handleClose();
          onUnauthorized();
          setTimeout(() => dispatch(setOpenSnackbar(false)), 300);
        }
      },
    }
  );

  return (
    <ModalLayout open={open} setOpen={handleClose} >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          <InfoFillCircle size={32} color={theme.palette.primary.main} />
          <Typography
            color={"primary.main"}
            sx={{
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            تایید دریافت بار{" "}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            overflowX: "hidden",
            maxHeight: "350px",
            minHeight: 0,
            gap: "8px",
          }}
        >
          <Box
            sx={{
              border: "1px solid",
              borderColor: blueGrey[100],
              borderRadius: "10px",
              padding: "8px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",

                //   border: "1px solid gray",

                borderWidth: "1px",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  backgroundColor: theme.palette.bgColor.blueGrey50,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "6px",
                  borderRadius: "8px",
                }}
              >
                <Boxoutline color={theme.palette.textColor.main} />
              </Box>

              <Box
                sx={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    {goodsName}
                  </Typography>
                  <Box
                    sx={{
                      // border: "1px solid gray",
                      display: "flex",
                      alignItems: "center",
                      paddingX: "4px",
                      paddingY: "4px",
                      borderRadius: "6px",
                      backgroundColor: theme.palette.bgColor.blueGrey50,
                      gap: "4px",
                    }}
                  >
                    <LocationFill size={18} color={theme.palette.info.dark} />
                    <Typography
                      color="textColor.main"
                      sx={{
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      {destination}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // backgroundColor: "primary.light",
                      padding: "4px",
                      borderRadius: "8px",
                      gap: "4px",
                    }}
                  >
                    {/* <BigCarIcon2 color={theme.palette.primary.main} /> */}
                    <Typography
                      noWrap
                      color="textColor.main"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      کرایه:{" "}
                    </Typography>
                    <Typography
                      color="success.main"
                      sx={{
                        fontSize: "16px",
                      }}
                    >
                      {addCommas(fare)}
                    </Typography>
                    <Typography
                      color="success.main"
                      sx={{
                        fontSize: "12px",
                      }}
                    >
                      ریال
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      borderRadius: "6px",
                      gap: "4px",
                    }}
                  >
                    {/* <Box
                      sx={{
                        backgroundColor: theme.palette.primary[50],
                        borderRadius: "5px",
                        paddingX: "4px",
                        paddingY: "4px",
                      }}
                    >
                      <Typography
                        noWrap
                        color="primary.main"
                        sx={{
                          fontSize: "10px",
                        }}
                      >
                        درحال برسی
                      </Typography>
                    </Box> */}
                    <Box
                      sx={{
                        backgroundColor: theme.palette.bgColor.blueGrey50,
                        borderRadius: "5px",
                        paddingX: "4px",
                        paddingY: "4px",
                      }}
                    >
                      <Typography
                        noWrap
                        color="textColor.main"
                        sx={{
                          fontSize: "12px",
                        }}
                      >
                        {ladingDate}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                boxShadow: `inset 8px 0 10px -4px rgba(0, 0, 0, 0.1),
        inset -8px 0 10px -4px rgba(0, 0, 0, 0.1),
        inset 0 8px 10px -4px rgba(0, 0, 0, 0.1),
        inset 0 -8px 10px -4px rgba(0, 0, 0, 0.1)`,
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                borderRadius: "8px",
                padding: "12px",
                overflowY: "auto",
                overflowX: "hidden",
                maxHeight: "220px",
                minHeight: 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  overflowWrap:"break-word",
                  wordWrap:"break-word",
                  wordBreak:"break-word"
                }}
              >
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "16px",
                    fontWeight: "700",
                    textAlign: "center",
                    color: "secondary.main",
                  }}
                >
                  توضیحات بار:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    textAlign: "justify",
                  }}
                >
                  {description}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "16px",
                    fontWeight: "700",
                    textAlign: "center",
                    color: "secondary.main",
                  }}
                >
                  آدرس مقصد:{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    textAlign: "justify",
                  }}
                >
                  {ladingLocationInfoAddress}
                </Typography>
              </Box>
            </Box>
          </Box>

         
        </Box>
         <Box
            sx={{
              display: "flex",
              gap: "8px",
             
            }}
          >
            <CustomButton
              flex={1}
              // loading
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => formik.handleSubmit()}
              title="بله، بار دریافت شود"
              bgColor="success.main"
              textColor="#fff"
              fWeight="700"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={<CheckCircle size={28} color={"#fff"} />}
            />
            <CustomButton
              type="outlined"
              rippleColor={theme.palette.primary.main}
              // loading
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => handleClose()}
              title="انصراف  از دریافت"
              fWeight="700"
              bgColor={theme.palette.primary[50]}
              textColor="primary.main"
              borderColor="primary.main"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={
                <CloseCircleSVG size={22} color={theme.palette.primary.main} />
              }
            />
          </Box>
      </Box>
    </ModalLayout>
  );
}
